import { combineReducers } from 'redux'
import basic from './basic'
export default combineReducers({
  basic // 基本信息
})
